<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px">
            <div class="shop-list">
                <draggable v-model="config[field.key]">
                    <el-row class="shop-item" v-for="(item,index) in config[field.key]" :key="index" type="flex"
                            justify="space-between">
                        <div class="link-name" v-text="config[field.key][index]['name']"></div>
                        <el-button size="small" @click="removeArticleItem(index)" class="del-btn">删除</el-button>
                    </el-row>
                </draggable>
            </div>
            <el-button size="small" @click="openDialog">添加店铺</el-button>
        </el-form-item>
        <!-- 店铺地址对话框 -->
        <el-dialog title="请选择链接" :visible.sync="dialog.visible" @close='closeDialog'>
            <normal-list :url="tableList.url" @close='closeDialog' :searchLabel="tableList.searchLabel"
                         :resultArrayName="tableList.resultArrayName" :titleName="tableList.titleName"
                         :count="tableList.count" :multi="tableList.multi" :idList="idList" @unSelect="unSelect"
                         @select="select"></normal-list>
        </el-dialog>
    </div>
</template>

<style lang="scss" scoped>
    .shop-list{
        margin-top: -5px;
    }
    .shop-item{
        cursor: pointer;
        padding: 5px 5px 5px 10px;
        &:hover{
            background: #F5F7FA;
        }
    }
    .del-btn{
        height: 32px;
        margin-top: 4px;
    }
</style>

<script>

  import draggable from 'vuedraggable';
  export default {
    name: 'tms-type-shop-list',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      config: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        dialog: {
          visible: false
        },
        linkNameList: {},
        currentIndex: 0,
        activeName: 'normal',
        tableList: {
          url: 'wdzg/b/cms/platform_shop/shop/list',
          searchLabel: '',
          titleName: 'name',
          resultArrayName: 'shop_list',
          count: 10,
          multi: true
        },
      }
    },

    computed: {
      idList() {
        let list = [];
        this.config[this.field.key].map((val) => {
          list.push(val.id);
        })
        return list;
      }
    },

    components: {
      draggable
    },

    created() {
    },

    methods: {
      openDialog() {
        this.dialog.visible = true;
      },
      removeArticleItem(index) {
        this.config[this.field.key].splice(index, 1);
      },
      handleUpload(src, index) {
        this.config[this.field.key][index].image_url = src;
      },
      openDialog(index) {
        this.currentIndex = index;
        this.dialog.visible = true;
      },
      closeDialog() {
        this.dialog.visible = false;
      },
      select(row) {
        row.cms_url = '/cms/page/biz/platform_shop/shop.html?id=' + row.id;
        this.config[this.field.key].push(row);
      },
      unSelect(row, index) {
        this.config[this.field.key].splice(index, 1);
      }
    }
  }

</script>
